package com.esoris.kmpmoout.features.expense.expense_form

import com.esoris.kmpmoout.navigation.AppRoute


data class ExpenseFormRoute(val default: String = "") : AppRoute